import React from 'react'
import Downshift from 'downshift'
import { Box, Flex, Icon, List, ListItem, Text } from '@chakra-ui/core'

export interface DropdownItem {
  label: string
  value: unknown
}

export interface DropdownProps {
  items: DropdownItem[]
  selected?: DropdownItem
  onChange: (item: DropdownItem) => void
}

export const Dropdown = ({ items, selected, onChange }: DropdownProps) => {
  const selectedProps = { ...(selected ? { selectedItem: selected } : { initialSelectedItem: items[0] }) }
  return (
    <Downshift
      onChange={(selection) => {
        onChange?.(selection as DropdownItem)
      }}
      itemToString={(item) => (item ? item.label : '')}
      {...selectedProps}
    >
      {({ getItemProps, getMenuProps, isOpen, selectedItem, getRootProps, toggleMenu }) => (
        <Box>
          <List
            borderTopLeftRadius=".4rem"
            borderTopRightRadius=".4rem"
            border={isOpen ? '1px solid' : 'none'}
            borderColor="primary.500"
            textTransform="capitalize"
            mb="0"
            px="0"
            borderBottom="none"
            {...getMenuProps()}
          >
            {isOpen
              ? items.map((item, index) => (
                  <ListItem
                    px="2rem"
                    cursor="pointer"
                    backgroundColor={selectedItem?.label === item.label ? 'gray.600' : 'transparent'}
                    color={selectedItem?.label === item.label ? 'primary.500' : 'initial'}
                    _hover={{ backgroundColor: 'gray.600' }}
                    {...getItemProps({
                      key: item.label,
                      index,
                      item,
                    })}
                  >
                    <Text fontSize="1.4rem" fontWeight="500" lineHeight="2.8rem" my="0" py="1.4rem">
                      {item.label}
                    </Text>
                  </ListItem>
                ))
              : null}
          </List>
          <Flex
            alignItems="center"
            justifyContent="space-between"
            borderRadius=".4rem"
            border="1px solid"
            borderColor={isOpen ? 'primary.500' : 'gray.100'}
            textTransform="capitalize"
            px="2rem"
            py="1.2rem"
            cursor="pointer"
            borderTopLeftRadius={isOpen ? 'none' : '.4rem'}
            borderTopRightRadius={isOpen ? 'none' : '.4rem'}
            onClick={() => {
              toggleMenu()
            }}
            {...getRootProps(undefined, { suppressRefError: true })}
          >
            <Text fontSize="1.4rem" fontWeight="500" lineHeight="2.8rem" color="primary.500">
              {selectedItem?.label}
            </Text>
            <Icon name={isOpen ? 'chevron-up' : 'chevron-down'} size="2rem"></Icon>
          </Flex>
        </Box>
      )}
    </Downshift>
  )
}
